var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"icp"},[_c('div',{staticStyle:{"font-size":"13px"}},[_vm._v("BizSpring 提供技术支持")])])
}]

export { render, staticRenderFns }